import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "offset": 24,
      "icon": "fa-chart-bar"
    }
  }, [_c(VRow, [_vm.packetsBar.individual && _vm.packetsBar.individual.length ? _c(VCol, {
    staticClass: "charts-min-height",
    attrs: {
      "cols": "12"
    }
  }, [_c(VCardText, {
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "text-right",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "float-left label pb-2"
  }, [_c('h6', [_vm._v("\n                      " + _vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.form.numberOfPackets')) + "\n                    ")])])])], 1)], 1), !_vm.loadingMetrics ? _c('niota-classic-charts-horizontal-bar', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "height": Math.max(200, _vm.packetsBar.common.labels.length * 15),
      "multi-chart-data": _vm.packetsBar
    }
  }) : _c(VSkeletonLoader, {
    attrs: {
      "type": "table-row-divider@3"
    }
  })], 1) : _vm._e(), _vm.rssiGraph.individual && _vm.rssiGraph.individual.length ? _c(VCol, {
    staticClass: "charts-line-min-height",
    attrs: {
      "cols": "12"
    }
  }, [_c(VCardText, {
    staticStyle: {
      "padding-top": "0",
      "padding-bottom": "0"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "text-right",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "float-left label pb-2"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.form.rssi')))])])])], 1)], 1), !_vm.loadingMetrics ? _c('niota-classic-charts-line', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "multi-chart-data-t": _vm.rssiGraph,
      "height": Math.max(250, 220 + _vm.packetsBar.common.labels.length * 5)
    }
  }) : _c(VSkeletonLoader, {
    attrs: {
      "type": "table-row-divider@4"
    }
  })], 1) : _vm._e(), _vm.lsnrGraph.individual && _vm.lsnrGraph.individual.length ? _c(VCol, {
    staticClass: "charts-line-min-height",
    attrs: {
      "cols": "12"
    }
  }, [_c(VCardText, {
    staticStyle: {
      "padding-top": "0",
      "padding-bottom": "0"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "text-right",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "float-left label pb-2"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.form.lsnr')))])])])], 1)], 1), !_vm.loadingMetrics ? _c('niota-classic-charts-line', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "multi-chart-data-t": _vm.lsnrGraph,
      "height": Math.max(250, 220 + _vm.packetsBar.common.labels.length * 5)
    }
  }) : _c(VSkeletonLoader, {
    attrs: {
      "type": "table-row-divider@4"
    }
  })], 1) : _vm._e(), _vm.sfGraph.individual && _vm.sfGraph.individual.length ? _c(VCol, {
    staticClass: "charts-line-min-height",
    attrs: {
      "cols": "12"
    }
  }, [_c(VCardText, {
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "text-right",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "float-left label pb-2"
  }, [_c('h6', [_vm._v("\n                      " + _vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.form.spreadingFactor')) + "\n                    ")])])])], 1)], 1), !_vm.loadingMetrics ? _c('niota-classic-charts-line', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "multi-chart-data-t": _vm.sfGraph,
      "height": Math.max(250, 220 + _vm.packetsBar.common.labels.length * 5)
    }
  }) : _c(VSkeletonLoader, {
    attrs: {
      "type": "table-row-divider@4"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };